<template>
  <div
    class="details-table-item"
    :class="{
      'details-table-item--mobile-align-center': mobileAlignCenter,
      'details-table-item--fixed-height': fixedHeight,
      'details-table-item--mobile': isMobileViewPrepared,
    }"
    :style="{ order }"
  >
    <details-table-left
      class="details-table-item__label"
      :class="leftClass"
      :label="label"
      :size="labelSize"
      :align-center="labelAlignCenter"
      :mobile-align-center="mobileAlignCenter"
      :tooltip="labelTooltip"
      :disabled="disabled"
      :loading="loading"
      :is-mobile-view="isMobileViewPrepared"
    >
      <slot name="label" />
    </details-table-left>

    <details-table-right
      :class="rightClass"
      :value="value"
      :align-center="labelAlignCenter"
      :mobile-align-center="mobileAlignCenter"
      :preserve-whitespace="preserveWhitespace"
      :auto-height="!fixedHeight"
      :disabled="disabled"
      :loading="loading"
      :is-mobile-view="isMobileViewPrepared"
      :padding-y="rightCellPaddingY"
    >
      <slot />
    </details-table-right>
  </div>
</template>

<script setup lang="ts">
import { computed } from '@/composition/vue/compositionApi'
import DetailsTableLeft from '@/components/shared/templates/details/DetailsTableLeft.vue'
import DetailsTableRight from '@/components/shared/templates/details/DetailsTableRight.vue'
import { useBreakpoints } from '@/composition/breakpoints'

const props = defineProps<{
  label?: string
  labelSize?: '' | 'large' | 'xLarge'
  mobileAlignCenter?: boolean
  labelAlignCenter?: boolean
  cellAlignCenter?: boolean
  labelTooltip?: string
  leftClass?: string
  rightClass?: string
  preserveWhitespace?: boolean
  value?: string | null
  disabled?: boolean
  loading?: boolean
  order?: number
  fixedHeight?: boolean
  isMobileView?: boolean
  rightCellPaddingY?: string
}>()

const { isMobile } = useBreakpoints()

const isMobileViewPrepared = computed(() => props.isMobileView || isMobile.value)
</script>

<style lang="scss" scoped>
.details-table-item {
  display: flex;
  min-height: 42px;
  line-height: 20px;
  color: $emphasize;
  box-sizing: content-box;

  &--fixed-height {
    height: 42px;
  }

  & + & {
    border-top: 1px solid $border-color;
  }

  &--mobile {
    flex-direction: column;
    min-height: unset;
    height: auto;

    .details-table-item__label {
      margin-bottom: 6px;
    }
    &.details-table-item--mobile-align-center {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }
}
</style>
